export const ReactQuestionData = [
  {
    question: "What is React?",
    answers: [
      "A JavaScript library for building user interfaces",
      "A programming language",
      "A database management system",
      "A web browser"
    ],
    correctAnswer: 0
  },
  {
    question: "What does JSX stand for?",
    answers: [
      "JavaScript XML",
      "JavaScript XHTML",
      "JavaScript XSLT",
      "JavaScript XUL"
    ],
    correctAnswer: 0
  },
  {
    question: "What is the virtual DOM?",
    answers: [
      "A JavaScript representation of the actual DOM",
      "A way to speed up DOM manipulation",
      "A type of DOM event",
      "A server-side DOM"
    ],
    correctAnswer: 0
  }
];

export default ReactQuestionData;
